import InputMask from 'react-input-mask'
import React, { useEffect, useState, useCallback } from 'react'
import * as yup from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import axios from 'axios'
import { toast } from 'react-toastify'
import parse from 'html-react-parser'
import { InvisibleSmartCaptcha } from '@yandex/smart-captcha'

import styles from './styles.module.scss'

const FormEduc = ({ setSuccessForm, setActivePopUp, checkDomenNameState, captchaSiteKey }) => {
  const [mobile, setMobile] = useState('')
  const [errorMobile, setErrorMobile] = useState(false)
  const [success2, setSuccess] = useState(false)
  const [blurSuccess, setBlurSuccess] = useState(false)
  const [directions, setDirections] = useState([])
  const [subscribe, setSubscribe] = useState(false)
  let _protocol = window.location.protocol

  const [token, setToken] = useState('')
  const [visible, setVisible] = useState(false)
  const handleChallengeHidden = useCallback(() => setVisible(false), [])
  const handleButtonClick = () => setVisible(true)

  const getDirections = async () => {
    try {
      const result = await axios({
        method: 'get',
        url: `${_protocol}//${checkDomenNameState}/api/v1/unit/direction`
      })
      setDirections(result.data)
    } catch (e) {
      toast.error('Ошибка загрузки вакансий')
    }
  }

  const schemaIceForm = yup
    .object({
      FIO: yup
        .string()
        .matches(/^[а-яА-ЯёЁ]+([-][а-яА-ЯёЁ]+)?(\s[а-яА-ЯёЁ]+){1,2}$/, 'Неверный формат данных')
        .required('Это обязательное поле'),
      city: yup
        .string()
        .matches(
          /^(([a-zA-Zа-яА-ЯёЁ]*(\s*)\([a-zA-Zа-яА-ЯёЁ\s]*\))|([a-zA-Zа-яА-ЯёЁ\-0-9]*)|([a-zA-Zа-яА-ЯёЁ]+[-|\s]?[a-zA-Zа-яА-ЯёЁ]*[-|\s]?[a-zA-Zа-яА-ЯёЁ]*[-|\s]?[a-zA-Zа-яА-ЯёЁ]*))$/,
          'Неверный формат данных'
        )
        .required('Это обязательное поле'),
      email: yup
        .string()
        .matches(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, 'Неверный формат данных')
        .required('Это обязательное поле'),
      unitDirection: yup.string().required('Это обязательное поле'),
    })
    .required()

  // setting form - inputs
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors, isValid }
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schemaIceForm)
  })

  const onChanges2 = data => {
    let checkFIO = watch('FIO')
    let finallyFIO = []
    if (checkFIO) {
      finallyFIO = checkFIO.split(' ')
    }

    const obj = {
      positionId: null,
      positionName: null,
      firstName: finallyFIO[1],
      middleName: finallyFIO[2],
      lastName: finallyFIO[0],
      city: data.city,
      unitName: null,
      phoneNumber: '' + mobile,
      email: data.email,
      link: null,
      info: null,
      course: null,
      faculty: null,
      department: null,
      unitDirection: data.unitDirection,
      university: null,
      nameEducation: null,
      dopinformation: null,
      subscribe: subscribe,
      type: 'CONTACTS_SUBSCRIBE',
      token: token,
    }

    const json = JSON.stringify(obj)
    const blob = new Blob([json], {
      type: 'application/json'
    })

    let saveRequest = new FormData()
    saveRequest.append('saveRequest', blob)

    mobile.length < 18 && setErrorMobile(true)
    !success2 && setBlurSuccess(true)

    if (mobile.length === 18 && success2) {
      axios({
        method: 'post',
        url: `${_protocol}//${checkDomenNameState}/api/v1/response/save`,
        data: saveRequest,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          if (response.data.status != "error") {
            setSuccessForm(true)
            reset()
            setMobile('')
            // eslint-disable-next-line no-undef
            ym(94755545,'reachGoal','stanovis-chastyu-komandy')

            // window._tmr = window._tmr || [];
            // window._tmr.push({ type: 'reachGoal', id: 3398932, goal: 'otpravit_zayavku' });
          } else {
            let _error = <>{parse(response.data.message)}</>
            toast.error(_error);
          }
        })
        .catch(() => {
          setSuccess(false)
          toast.error('Отклик не отправился!')
        })
        .finally(() => {
          setBlurSuccess(false)
          setErrorMobile(false)
        })
    }
  }

  useEffect(() => {
      setSuccessForm(false)
      getDirections()
  }, [])

  return (
    <div>
      <form className={styles.form_block_listing_wrapper} onSubmit={handleSubmit(onChanges2)}>
        <div
          className={errors.FIO?.message ? styles.form_block_listing_item_error : styles.form_block_listing_item}
        >
          <label htmlFor='FIO'>Фамилия, имя, отчество</label>
          <input
            {...register('FIO')}
            placeholder='Например, Иванов Иван Иванович'
            type='text'
            name='FIO'
            maxLength='50'
            className='placeholder-gray-400'
          />
          {errors?.FIO && <p className={styles.left_input_error}>{errors.FIO?.message}</p>}
        </div>

        <div className='flex justify-between max-lg:flex-col'>
          <div
            className={errors.city?.message ? styles.form_block_listing_item2_error : styles.form_block_listing_item2}
          >
            <label htmlFor='city'>Город</label>
            <input {...register('city')} placeholder='Например, Москва' type='text' name='city'
              className='placeholder-gray-400' />
            {errors?.city && <p className={styles.left_input_error}>{errors.city?.message}</p>}
          </div>
          <div
            className={
              errors.unitDirection?.message ? styles.form_block_listing_item2_error : styles.form_block_listing_item2
            }
          >
            <label htmlFor='unitDirection'>Направление</label>
            <select {...register('unitDirection')} name='unitDirection' className="placeholder-gray-400">
              <option value=''>Выберите направление</option>
              {directions &&
                directions.map(item => (
                  <option value={item} className={styles.input_select_option}>
                    {item}
                  </option>
                ))}
            </select>
            {errors?.unitDirection && <p className={styles.left_input_error}>{errors.unitDirection?.message}</p>}
          </div>
        </div>

        <div className='flex justify-between max-lg:flex-col'>
          <div
            className={
              errorMobile && mobile?.length !== 18
                ? styles.form_block_listing_item2_error
                : styles.form_block_listing_item2
            }
          >
            <label htmlFor='telephone'>Телефон</label>
            <InputMask
              mask="+7 (999) 999-99-99"
              value={mobile}
              onChange={e => setMobile(e.target.value)}
              className="placeholder-gray-400"
              label="telephone"
              autoComplete="off"
              placeholder="Например, +7 (777) 777-77-77"
            >
            </InputMask>
            {errorMobile && mobile?.length !== 18 &&
              <p className={styles.left_input_error}>Неверный формат номера</p>}
            {errorMobile && mobile?.length === 0 &&
              <p className={styles.left_input_error}>Это обязательное поле</p>}
          </div>
          <div
            className={errors.email?.message ? styles.form_block_listing_item2_error : styles.form_block_listing_item2}
          >
            <label htmlFor='email'>Электронная почта</label>
            <input {...register('email')} placeholder='Например, example@example.com' type='email'
              name='email' className='placeholder-gray-400' />
            {errors?.email && <p className={styles.left_input_error}>{errors.email?.message}</p>}
          </div>
        </div>

        <div
          className={
            !success2 && blurSuccess ? styles.form_block_listing_checkbox_error : styles.form_block_listing_checkbox
          }
        >
          <input onClick={() => {setSuccess(!success2); handleButtonClick();}} type='checkbox' id='agreement' name='agreement' className={styles.agreement} />
          <label htmlFor='agreement'>
            <p>
              Я даю согласие на{' '}
              <a href='/privacy-policy' target='_blank'>
                <span onClick={() => setActivePopUp(null)}>обработку моих персональных данных</span>
              </a>{' '}
            </p>
          </label>
          {success2 === false && blurSuccess === true && (
            <p className={styles.left_input_error}>Эта галочка обязательна!</p>
          )}
        </div>

        <div className={styles.form_block_listing_checkbox + ' ' + styles['form_block_listing_checkbox--mb']}>
          <input onClick={() => setSubscribe(!subscribe)} type='checkbox' id='subscribe' name='subscribe' className={styles.subscribe} />
          <label htmlFor='subscribe'>
            <p>
              Я даю согласия на получение рассылок нерекламного характера от Generium
            </p>
          </label>
        </div>

        <InvisibleSmartCaptcha
          sitekey={captchaSiteKey}
          onSuccess={setToken}
          onChallengeHidden={handleChallengeHidden}
          visible={visible}
        />

        <button className={styles.form_block_listing_btn_active}>
          Отправить
          <span>&rarr;</span>
        </button>
      </form>
    </div>
  )
}

export default FormEduc
